import React, { useState, useEffect } from 'react';
import { getTeamCrest, onCrestsLoaded } from '../../utils/teamLogos';

// Cor de fallback por clube (quando logo não carrega)
const TEAM_FALLBACK = {
  'Grêmio':        { bg: 'bg-blue-600',    text: 'text-white', label: 'GRE' },
  'Internacional': { bg: 'bg-red-600',     text: 'text-white', label: 'INT' },
  'Athletico-PR':  { bg: 'bg-red-700',     text: 'text-white', label: 'CAP' },
  'Coritiba':      { bg: 'bg-green-700',   text: 'text-white', label: 'CFC' },
  'Chapecoense':   { bg: 'bg-green-600',   text: 'text-white', label: 'CHA' },
  'Corinthians':   { bg: 'bg-zinc-900',    text: 'text-white', label: 'COR' },
  'Palmeiras':     { bg: 'bg-green-800',   text: 'text-white', label: 'PAL' },
  'Santos':        { bg: 'bg-white',       text: 'text-black', label: 'SAN', border: 'border border-slate-300' },
  'São Paulo':     { bg: 'bg-red-600',     text: 'text-white', label: 'SPF' },
  'Flamengo':      { bg: 'bg-red-600',     text: 'text-white', label: 'FLA' },
  'Fluminense':    { bg: 'bg-red-800',     text: 'text-white', label: 'FLU' },
  'Vasco':         { bg: 'bg-zinc-900',    text: 'text-white', label: 'VAS' },
  'Botafogo':      { bg: 'bg-zinc-900',    text: 'text-white', label: 'BOT' },
  'Atlético-MG':   { bg: 'bg-zinc-900',    text: 'text-white', label: 'CAM' },
  'Cruzeiro':      { bg: 'bg-blue-700',    text: 'text-white', label: 'CRU' },
  'América-MG':    { bg: 'bg-green-700',   text: 'text-white', label: 'AMG' },
  'Bahia':         { bg: 'bg-blue-500',    text: 'text-white', label: 'BAH' },
  'Fortaleza':     { bg: 'bg-red-500',     text: 'text-white', label: 'FOR' },
  'Ceará':         { bg: 'bg-zinc-900',    text: 'text-white', label: 'CEA' },
  'Sport':         { bg: 'bg-red-700',     text: 'text-white', label: 'SPT' },
  'Náutico':       { bg: 'bg-red-600',     text: 'text-white', label: 'NAU' },
  'Goiás':         { bg: 'bg-green-600',   text: 'text-white', label: 'GOI' },
  'Cuiabá':        { bg: 'bg-yellow-500',  text: 'text-black', label: 'CUI' },
};

// size: 'sm' (inline listas, 20px) | 'xs' (overlay no campo, 16px) | 'md' (perfil, 28px)
const TeamFlag = ({ team, size = 'sm' }) => {
  const [imgFailed, setImgFailed] = useState(false);
  // Re-render quando o cache de logos popular — via listener, não polling
  const [crestUrl, setCrestUrl] = useState(() => getTeamCrest(team));
  useEffect(() => {
    if (crestUrl) return undefined; // já tem
    const unsub = onCrestsLoaded(() => {
      const url = getTeamCrest(team);
      if (url) setCrestUrl(url);
    });
    return unsub;
  }, [team, crestUrl]);

  if (!team || team === 'Sem Time') return null;
  const fallback = TEAM_FALLBACK[team];
  if (!crestUrl && !fallback) return null;

  const dim = size === 'xs' ? 'w-4 h-4' : size === 'md' ? 'w-7 h-7' : 'w-5 h-5';

  if (crestUrl && !imgFailed) {
    return (
      <div className={`${dim} rounded-full overflow-hidden bg-white shadow-sm flex-shrink-0 flex items-center justify-center`} title={team}>
        <img
          src={crestUrl}
          alt={team}
          className="w-full h-full object-contain p-[1px]"
          onError={() => setImgFailed(true)}
        />
      </div>
    );
  }

  if (!fallback) return null;
  const xs = size === 'xs';
  return (
    <div
      className={`inline-flex items-center justify-center rounded-full font-black shadow-sm flex-shrink-0
        ${dim} ${xs ? 'text-[6px]' : 'text-[8px]'}
        ${fallback.bg} ${fallback.text} ${fallback.border || ''}`}
      title={team}
    >
      {xs ? fallback.label.slice(0, 2) : fallback.label}
    </div>
  );
};

export default TeamFlag;